import { searchForHits } from '@iheartjane/algolia';
import type { SearchProps, SearchResponse } from '@iheartjane/algolia';
import { config } from '@iheartjane/config';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

export function useSearch<T>({ enabled = true, ...params }: SearchProps<T>) {
  return useQuery({
    enabled,
    queryFn: () => search<T>(params),
    queryKey: ['searchResponse', JSON.stringify(params)],
  });
}

export function useInfiniteSearch<T>({
  enabled = true,
  ...params
}: SearchProps<T>) {
  return useInfiniteQuery({
    enabled,
    queryFn: ({ pageParam }: { pageParam?: number }) =>
      search<T>({ ...params, page: pageParam }),
    queryKey: ['infiniteSearchResponse', JSON.stringify(params)],
    getNextPageParam: (lastPage) => {
      const maybeNextPage = (lastPage?.page ?? 0) + 1;
      const hasNextPage = maybeNextPage < (lastPage?.nbPages ?? 0);
      return hasNextPage ? maybeNextPage : undefined;
    },
  });
}

export async function search<T>(
  args: SearchProps<T>
): Promise<SearchResponse<T>> {
  return await searchForHits(
    {
      algoliaEnv: config.algoliaEnv,
      apiKey: config.algoliaApiKey,
      appId: config.algoliaAppId,
      url: config.algoliaUrl,
    },
    args
  );
}
